<div class="d-flex flex-column justify-content-between" style="min-height: 128px; height: 100%">
  <div class="mt-3">
    <div class="row">
      <div class="col p-0 pt-2 pl-3">
        <p class="font-poppins title-item m-0">
          {{ item.title ? stingUpperCase(item.title) : stingUpperCase(item.title) }}
          <span class="d-flex flex-nowrap" *ngIf="item.categoryName === 'DISNEY' || item.categoryName === 'HOTELS'">
            <ng-container *ngIf="item.categoryName === 'HOTELS' && stars && stars.length > 0">
              <i *ngFor="let star of stars(); let i = index" class="icon-estrella"></i>
            </ng-container>
          </span>
        </p>
        <p class="room-type mt-1 mb-0"> {{getCategoryName(item?.categoryName, item)}}</p>
        <span *ngIf="item.categoryName === 'RENT-A-CAR'" class="font-lato room-type" style="line-height: 1">
          {{ item?.category }} , {{ (item?.type_definition).length > 80 ? item.type_definition.substring(0, 80) : item?.type_definition }}
        </span>
        <div *ngIf="item.categoryName === 'RENT-A-CAR'" class="room-type">
            <span><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
        </div>
        <div *ngIf="item.categoryName === 'HOTELS'" class="font-poppins location-text m-0">
          <div class="rooms-details d-flex flex-column font-poppins location-text" style="width: 100% !important">
            <div class="room-type mt-2">
              <span>{{ item.roomType }}</span>
            </div>
            <div class="room-type">
              <span>{{ item?.boardName }}</span>
            </div>
            <div class="room-type">
              <span><b>Pasajeros: </b> {{ item?.adults }} {{item?.adults > 1 ? 'adultos' : 'adulto'}}, {{item?.childrens}} {{item?.childrens > 1 ? 'niños' : 'niño'}} {{item?.childrens > 0 ? getAgesInItem(item) : ''}}</span>
            </div>
            <div class="my-2 rate-class d-flex align-items-center position-relative">
              <p class=" date-room" [ngStyle]="{ color: item.rateClassId == 'R' ? '#02d498' : '#d60159', 'margin-bottom': itemRateClass === 'R' ? '0' : '6px' }">
                {{ item.rateClassId == "R" ? "Reembolsable" : "No reembolsable" }}
              </p>
              <div class="info-tool info-tool--policies d-flex flex-column mb-1"
                   [class.is-open]="cancellationTooltipOpen"
                   (mouseenter)="cancellationTooltipOpen = true"
                   (mouseleave)="cancellationTooltipOpen = false" *ngIf="item?.room?.cancellationPolicy && item?.room?.cancellationPolicy.length > 0 && itemRateClass === 'R'">
                  <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                <span class="tooltip-info tooltip-info--policies shadow-md">
                  <usb-cancellation-policies
                    class="accordion-item-policies usb-cancellation-policies--in-tooltip"
                    #politicsSection
                    [cancellationPolicies]="itemCancellationPolicies(item.categoryName, item)"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [compact]="true"
                    [categoryId]="1">
                  </usb-cancellation-policies>
                </span>
              </div>
            </div>

            <div class="date-room" style="margin-bottom: 4px" *ngIf="item.categoryName === 'HOTELS'">
              <i class="bi bi-geo-alt-fill font-verde"></i>
              <span class="date-room"> {{ item.form?.destination?.city_name || item.form?.destination?.name || "No especificado" }}</span>
            </div>

            <div class="date-room" *ngIf="item.categoryName === 'HOTELS'">
              <span><b>In - Out:</b> {{ item.arrivalDate | date: "dd/MM/yy" }} - {{ item.departureDate | date: "dd/MM/yy" }}</span>
            </div>
            <div class="d-flex flex-column flex-wrap date-room" *ngIf="item.categoryName === 'HOTELS'">
              <span
                ><b>Check In: </b> {{ item?.checkTimes?.checkIn && item.checkTimes.checkIn.trim() ? item.checkTimes.checkIn : "N/A" }}</span
              >
              <span
                ><b>Check Out: </b>
                {{ item?.checkTimes?.checkOut && item.checkTimes.checkOut.trim() ? item.checkTimes.checkOut : "N/A" }}</span
              >
            </div>

            <!-- item.resultReserve?.additionalInfo?.rooms[0]?.paxList -->
            <div *ngIf="paxInfoValidate(item)" class="date-room" style="width: 100% !important">
              <span
                ><b>Pasajero:</b> {{ item.resultReserve?.additionalInfo?.rooms[0]?.paxList[0].firstName }}
                {{ item.resultReserve?.additionalInfo?.rooms[0]?.paxList[0].lastName }}</span
              >
            </div>
          </div>
          <!-- Puede que la variable de hotelReservationId cambie a providerReservationId -->
          <div class="mt-2 d-flex date-room" style="gap: 0.5em" *ngIf="item?.resultReserve && item?.resultReserve?.providerReservationId">
            <p class="mb-0"><b>Localizador:</b> {{ item?.resultReserve?.providerReservationId }}</p>
            <i
              class="bi bi-clipboard-check text-semiblack"
              style="cursor: pointer"
              (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"
            ></i>
          </div>
        </div>
        <div *ngIf="item.categoryName === 'TRANSPORTS'" class="font-poppins location-text m-0 mt-2">
          <div class="rooms-details d-flex flex-column font-poppins location-text" style="width: 100% !important">
            <div *ngIf="item?.firstWay" class="room-type" style="width: 15rem">
              <span>{{ getTypeWay(item?.firstWay) }}</span>
            </div>
            <div class="room-type" style="width: 15rem">
              <span>{{ item.transferType }}</span>
            </div>
            <div class="room-type" style="width: 15rem">
              <span>{{ item.vehicle.type }}</span>
            </div>
            <div class="room-type">
              <span><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
            </div>
            <div  class="rate-class d-flex position-relative mt-2">
              <span class=" date-room" [ngStyle]="{ color: item.pricing.rateClass == 'R' ? '#02d498' : '#d60159' , 'margin-bottom': itemRateClass === 'R' ? '0' : '6px'}">{{
                item.pricing.rateClass == "R" ? "Reembolsable" : "No reembolsable"
              }}</span>
              <div class="info-tool info-tool--policies d-flex flex-column mb-1"
                   [class.is-open]="cancellationTooltipOpen"
                   (mouseenter)="cancellationTooltipOpen = true"
                   (mouseleave)="cancellationTooltipOpen = false" *ngIf="item?.cancellationPolicies && item?.cancellationPolicies.length > 0 && itemRateClass === 'R'">
                <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                <span class="tooltip-info tooltip-info--policies shadow-md">
                  <usb-cancellation-policies
                    class="accordion-item-policies usb-cancellation-policies--in-tooltip"
                    #politicsSection
                    [cancellationPolicies]="itemCancellationPolicies(item.categoryName, item)"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [compact]="true"
                    [categoryId]="8">
                  </usb-cancellation-policies>
                </span>
              </div>
            </div>

            <div *ngIf="paxInfoValidate(item)" class="date-room" style="width: 100% !important">
              <span class="date-room"
                ><b>Pasajero:</b> {{ item.resultReserve?.additionalInfo?.rooms[0]?.paxList[0].firstName }}
                {{ item.resultReserve?.additionalInfo?.rooms[0]?.paxList[0].lastName }}</span
              >
            </div>
          </div>
          <div class="date-room">
            <b>Pick up:</b> <span style="text-transform: capitalize"> {{ extractNameTransport(item, "origin") }}</span>
          </div>
          <div class="date-room">
            <b>Drop off:</b> <span style="text-transform: capitalize"> {{ extractNameTransport(item, "destination") }}</span>
          </div>
          <div
            *ngIf="item.amenitiesIncluded && item.amenitiesIncluded.length > 0"
            class="date-room d-flex align-items-center mt-1"
            style="gap: 0.5em"
          >
            <span><b>Adicionales:</b></span>
            <div
              class="info-tool info-tool--policies d-flex flex-column mb-1"
              [class.is-open]="addonsTooltipOpen"
              (mouseenter)="addonsTooltipOpen = true"
              (mouseleave)="addonsTooltipOpen = false"
            >
              <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
              <span class="tooltip-info tooltip-info--policies shadow-md">
                <div class="d-flex flex-column px-3 py-2" style="min-width: 220px;">
                  <ng-container *ngFor="let addon of item.amenitiesIncluded">
                    <div class="d-flex align-items-center justify-content-between" style="gap: 0.5em; padding: 2px 0;">
                      <span style="font-size: 12px; text-transform: lowercase;">{{ addon?.name || addon?.description }}</span>
                      <span class="d-flex align-items-center" style="gap: 0.25em;">
                        <span style="font-size: 12px; font-weight: 500;">{{ currencyAgency?.code }} {{ (addon?.totalPrice || addon?.priceProf || addon?.price || 0) | currencyConverter: item?.pricing?.currency: currencyAgency?.code: currencies | number: '1.2-2' }}</span>
                        <usb-tooltip-convert-amount
                          [currencyProduct]="item?.pricing?.currency"
                          [valueProduct]="addon?.totalPrice || addon?.priceProf || addon?.price || 0"
                          [clientsSettingAppBooking]="clientsSettingAppBooking"
                        ></usb-tooltip-convert-amount>
                      </span>
                    </div>
                  </ng-container>
                </div>
              </span>
            </div>
          </div>
          <div class="date-room d-flex flex-column mt-1">
            <span
              ><b>Inicio:</b> {{ item.arrivalDate | date: "dd/MM/yy" }}&nbsp;&nbsp;&nbsp;({{
                item.payload[0].transfers.pickupTime ? item.payload[0].transfers.pickupTime : item.payload[0].transfers.pickUpTime
              }}
              hs. - {{ getMessageFirstTime("origin", item?.payload[0].transfers.pickupLocation) }})</span
            >
          </div>
          <div *ngIf="item.status_id === 2" class="date-room">
            <b>Conductor:</b> {{ item.resultReserve?.additionalInfo?.reservationDetailTransfer?.driver?.driverName }}
          </div>
          <div *ngIf="item.status_id === 2" class="date-room">
            <b>Contacto conductor:</b> {{ item.resultReserve?.additionalInfo?.reservationDetailTransfer?.driver?.driverContact }}
          </div>
          <div
            class="mt-2 d-flex align-items-center date-room"
            style="gap: 0.5em"
            *ngIf="item?.resultReserve && item?.resultReserve?.providerReservationId"
          >
            <p class="mb-0"><b>Localizador:</b> {{ item?.resultReserve?.providerReservationId }}</p>
            <i
              class="bi bi-clipboard-check text-semiblack"
              style="cursor: pointer"
              (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"
            >
            </i>
          </div>
        </div>
        <div *ngIf="item.categoryName === 'RENT-A-CAR'" class="font-poppins location-text m-0 mt-2">
          <div class="rate-class d-flex position-relative">
            <span class="date-room" [ngStyle]="{ color: item.rateClass == 'R' ? '#02d498' : '#d60159', 'margin-bottom': itemRateClass === 'R' ? '0' : '6px' }">{{
              item.rateClass == "R" ? "Reembolsable" : "No reembolsable"
            }}</span>
            <div class="info-tool info-tool--policies d-flex flex-column mb-1"
                   [class.is-open]="cancellationTooltipOpen"
                   (mouseenter)="cancellationTooltipOpen = true"
                   (mouseleave)="cancellationTooltipOpen = false" *ngIf="item?.cancellationPolicies && item?.cancellationPolicies.length > 0 && itemRateClass === 'R'">
                <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                <span class="tooltip-info tooltip-info--policies shadow-md">
                  <usb-cancellation-policies
                    class="accordion-item-policies usb-cancellation-policies--in-tooltip"
                    #politicsSection
                    [cancellationPolicies]="itemCancellationPolicies(item.categoryName, item)"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [compact]="true"
                    [categoryId]="2">
                  </usb-cancellation-policies>
                </span>
              </div>
          </div>
          <div class="date-room">
            <b>Lugar de Recogida:</b> {{ item?.pickupSelected ? item?.pickupSelected.name : "" }} ({{
              item?.pickupSelected ? item?.pickupSelected?.address : ""
            }})
          </div>
          <div class="date-room">
            <b>Lugar de Entrega:</b> {{ item?.dropoffSelected ? item?.dropoffSelected?.name : "" }} ({{
              item?.dropoffSelected ? item?.dropoffSelected?.address : ""
            }})
          </div>
          <!-- <div *ngIf="item.selectOptional?.length >= 1" class="date-room">
              <span>Extras Seleccionados ({{item.selectOptional?.length}}): </span>
            </div> -->
          <!-- <div class="date-room" *ngFor="let optional of item.selectOptional">
              <strong>
                {{optional?.Name}}
              </strong>
            </div> -->
          <div class="mt-2 d-flex date-room" style="gap: 0.5em" *ngIf="item?.resultReserve && item?.resultReserve?.providerReservationId">
            <p class="mb-0"><b>Localizador:</b> {{ item?.resultReserve?.providerReservationId }}</p>
            <i
              class="bi bi-clipboard-check text-semiblack"
              style="cursor: pointer"
              (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"
            ></i>
          </div>
        </div>
        <div *ngIf="item.categoryName === 'TOURS'" class="font-poppins location-text m-0">
          <p class="date-room mb-0 mt-2" *ngIf="item.categoryName == 'TOURS'">
            <ng-container *ngIf="item.categoryId === 6">
               {{ item?.experience?.option_name }}
            </ng-container>
           <ng-container *ngIf="item.categoryId === 9">
             {{ item?.ticket?.option_name }}
           </ng-container>
          </p>
           <span><b>Pasajeros: </b> {{ item?.adults }} {{item?.adults > 1 ? 'adultos' : 'adulto'}}, {{item?.childrens}} {{item?.childrens > 1 ? 'niños' : 'niño'}} {{item?.childrens > 0 ? getAgesInItem(item) : ''}}</span>
          <div  class="rate-class d-flex position-relative mt-2">
            <span
              class="date-room"
              [ngStyle]="{
                color: item.rateClassId == 'R' ? '#02d498' : '#d60159',
                'margin-bottom': item.rateClassId == 'R' ? '0' : '6px'
              }"
              >{{ item.rateClassId == "R" ? "Reembolsable" : "No reembolsable" }}</span
            >
            <div class="info-tool info-tool--policies d-flex flex-column mb-1"
                   [class.is-open]="cancellationTooltipOpen"
                   (mouseenter)="cancellationTooltipOpen = true"
                   (mouseleave)="cancellationTooltipOpen = false" *ngIf="item?.cancellationPolicies.cancellationPolicies && item?.cancellationPolicies.cancellationPolicies.length > 0 && itemRateClass === 'R'">
                <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                <span class="tooltip-info tooltip-info--policies shadow-md">
                  <usb-cancellation-policies
                    class="accordion-item-policies usb-cancellation-policies--in-tooltip"
                    #politicsSection
                    [cancellationPolicies]="itemCancellationPolicies(item.categoryName, item)"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [compact]="true"
                    [categoryId]="6">
                  </usb-cancellation-policies>
                </span>
              </div>
          </div>

          <!-- <ul *ngIf="item.categoryName == 'TOURS' && item?.serviceExtra && item?.serviceExtra.length > 0" style="list-style: none; padding: 0;">
              <li *ngFor="let optional of item.serviceExtra">
                {{optional.name}} - ${{optional.price}}
              </li>
            </ul> -->
          <i class="bi bi-geo-alt-fill font-verde"></i>
          <span class="date-room"> {{ item.form?.destination?.city_name || item.form?.destination?.name || "No especificado" }}</span>
          <div class="date-room">
            <span><b>In - Out:</b> {{ item.arrivalDate | date: "dd/MM/yy" }} - {{ item.departureDate | date: "dd/MM/yy" }}</span>
          </div>
          <div class="date-room">
            <ng-container *ngIf="item.subCategoryId === 6 && item?.experience?.sessions">
              <b>Inicio:</b> {{ item?.experience?.sessions }} hs.
            </ng-container>
            <ng-container *ngIf="item.subCategoryId === 9 && item?.selectHour"> <b>Inicio:</b> {{ item?.selectHour }} hs. </ng-container>
          </div>
          <div class="mt-2 d-flex date-room" style="gap: 0.5em" *ngIf="item?.resultReserve && item?.resultReserve?.providerReservationId">
            <p class="mb-0"><b>Localizador:</b> {{ item?.resultReserve?.providerReservationId }}</p>
            <i
              class="bi bi-clipboard-check text-semiblack"
              style="cursor: pointer"
              (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"
            ></i>
          </div>
        </div>
        <div *ngIf="item.categoryName === 'INSURANCE'" class="font-poppins location-text m-0 mt-2">
          <p class="room-type mb-0">
            {{ item.form?.serviceType }}
          </p>

            <span><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>

          <div class="rate-class d-flex position-relative mt-2">
            <span class="date-room" [ngStyle]="{ color: item.rateClass == 'R' ? '#02d498' : '#d60159', 'margin-bottom': itemRateClass === 'R' ? '0' : '6px' }">{{
              item.rateClass == "R" ? "Reembolsable" : "No reembolsable"
            }}</span>
            <div class="info-tool info-tool--policies d-flex flex-column mb-1"
                   [class.is-open]="cancellationTooltipOpen"
                   (mouseenter)="cancellationTooltipOpen = true"
                   (mouseleave)="cancellationTooltipOpen = false" *ngIf="item?.cancellationPolicies && item?.cancellationPolicies.length > 0 && itemRateClass === 'R'">
                <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                <span class="tooltip-info tooltip-info--policies shadow-md">
                  <usb-cancellation-policies
                    class="accordion-item-policies usb-cancellation-policies--in-tooltip"
                    #politicsSection
                    [cancellationPolicies]="itemCancellationPolicies(item.categoryName, item)"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [compact]="true"
                    [categoryId]="10">
                  </usb-cancellation-policies>
                </span>
              </div>
          </div>
          <div class="date-room">
            <span class="date-room">
              <b>In - Out:</b> {{ item.arrivalDate | date: "dd/MM/yy" }} - {{ item.departureDate | date: "dd/MM/yy" }}</span
            >
          </div>

          <div class="date-room">
            <b>Origen:</b> <span style="text-transform: capitalize"> {{ item?.form?.begin }}</span>
          </div>
          <div class="date-room">
            <b>Destino:</b> <span style="text-transform: capitalize"> {{ item?.form?.destination?.label }}</span>
          </div>

          <div
            class="mt-2 d-flex date-room"
            style="gap: 0.5em"
            *ngIf="item?.resultReserve && item?.resultReserve?.reservation?.providerReservationId"
          >
            <p class="mb-0"><b>Localizador:</b> {{ item?.resultReserve?.reservation?.providerReservationId }}</p>
            <i
              class="bi bi-clipboard-check text-semiblack"
              style="cursor: pointer"
              (click)="copyToClipboard(item?.resultReserve?.reservation?.providerReservationId)"
            ></i>
          </div>
        </div>
      </div>


    </div>
          <div
            class="mt-2 d-flex date-room"
            style="gap: 0.5em"
          >
            <p class="mb-0"><span style="font-weight: 600">Producto ID:</span> {{ item?.id }}</p>
      </div>
  </div>

  <div class="row mb-3">
    <div class="col-9 p-0 pt-2 pl-3" *ngIf="item.status_id != 5">
      <div class="row">
        <div class="col d-flex align-items-end justify-content-between">
          <div class="d-flex">
            <div class="d-flex flex-row align-items-center container-btn-tickets" style="gap: 0.5em">
              <span *ngIf="permissionsMap['booking.itinerarios.voucher'] && (item.status_id === 2 || item.status_id === 10)">
                <img
                  src="../../../../assets/icons/itinerary-detail/VOUCHER.svg"
                  (click)="vouchersReservationPdf(item.id)"
                  style="width: 12.5px; cursor: pointer"
                  tooltip="Descargar voucher"
                  placement="bottom"
                  alt="Descargar voucher"
                />
                <!-- <i class="i-voucher mr-2  btn-voucher"

                (click)="vouchersReservationPdf(item.id)"

                visible="item.status_id === 2" *ngIf="item.status_id === 2"></i> -->
              </span>
              <div
                class="separator"
                *ngIf="
                  (permissionsMap['booking.itinerarios.elminarproducto'] ||
                    permissionsMap['booking.itinerarios.editarproducto'] ||
                    permissionsMap['booking.itinerarios.agregarproducto']) &&
                  item.source === 'Web' &&
                  !item.isPendigApprovePay &&
                  !item.isPaidAgency &&
                  !item.isPaidProvider &&
                  !item.isBilled
                "
              ></div>
              <!-- *ngIf="item.status_id === 1 || item.status_id === 4 || item.status_id === 5"-->
              <span *ngIf="permissionsMap['booking.itinerarios.elminarproducto'] &&
                            item.status !== 'Reservado' &&
                            item.status_id !== 10 &&
                            item.source === 'Web'">
                <img
                  src="../../../../assets/icons/itinerary-detail/ELIMINAR.svg"
                  (click)="removeItem()"
                  style="width: 16px; cursor: pointer"
                  tooltip="Eliminar producto"
                  placement="bottom"
                  alt="Eliminar producto"
                />
                <!-- <i class="i-delete btn-eliminar"  (click)="removeItem()"></i> -->
              </span>
              <span
                *ngIf="
                  item.categoryName == 'TOURS' &&
                  item.subCategoryId !== 9 &&
                  permissionsMap['booking.itinerarios.elminarproducto'] &&
                  item.status == 'Reservado' &&
                  item.source === 'Web' &&
                  !item.isPendigApprovePay &&
                  !item.isPaidAgency &&
                  !item.isPaidProvider &&
                  !item.isBilled
                "
              >
                <img
                  src="../../../../assets/icons/itinerary-detail/04-01.svg"
                  style="width: 18px; cursor: pointer"
                  tooltip="Cancelar reserva"
                  placement="bottom"
                  (click)="removeItem()"
                  alt="Cancelar reserva"
                />
                <!-- <i class="i-cancelar btn-cancelar"  (click)="removeItem()"></i> -->
              </span>
              <span
                *ngIf="
                  item.categoryName != 'TOURS' &&
                  permissionsMap['booking.itinerarios.elminarproducto'] &&
                  item.status == 'Reservado' &&
                  item.source === 'Web' &&
                  !item.isPendigApprovePay &&
                  !item.isPaidAgency &&
                  !item.isPaidProvider &&
                  !item.isBilled
                "
              >
                <img
                  src="../../../../assets/icons/itinerary-detail/04-01.svg"
                  style="width: 18px; cursor: pointer"
                  tooltip="Cancelar reserva"
                  (click)="removeItem()"
                  placement="bottom"
                  alt="Cancelar reserva"
                />
                <!-- <i class="i-cancelar btn-cancelar"  (click)="removeItem()"></i> -->
              </span>
              <span
                *ngIf="
                  permissionsMap['booking.itinerarios.editarproducto'] &&
                  item.status_id === 1 &&
                  !item.isPaidAgency &&
                  validDateUpdate(item.arrivalDate) &&
                  item.source === 'Web'
                "
              >
                <img
                  src="../../../../assets/icons/itinerary-detail/EDITAR-01.svg"
                  style="width: 18px; cursor: pointer"
                  tooltip="Editar producto"
                  placement="bottom"
                  (click)="edit()"
                  alt="Editar producto"
                />
                <!-- <i class="i-edit btn-editar"  *ngIf="!item.isPaidAgency" (click)="edit()"></i> -->
              </span>
              <span
                *ngIf="
                  permissionsMap['booking.itinerarios.agregarproducto'] &&
                  !item.isPaidAgency &&
                  validDateUpdate(item.arrivalDate) &&
                  item.source === 'Web'
                "
              >
                <img
                  src="../../../../assets/icons/itinerary-detail/AGREGAR-01.svg"
                  style="width: 18px; cursor: pointer"
                  tooltip="Agregar producto"
                  placement="bottom"
                  (click)="updateItem(item)"
                  alt="Agregar producto"
                />
              </span>

              <span>
                <img
                  src="../../../../assets/icons/itinerary-detail/ICONO_DETALLE-01.svg"
                  style="width: 18px; cursor: pointer"
                  tooltip="Ver detalle del producto"
                  placement="bottom"
                  (click)="openModalItem(item, 'detail')"
                  alt="Ver detalle del producto"
                />
              </span>

              <span *ngIf="validCreateCommentProduct(item)">
                <img
                  src="../../../../assets/icons/itinerary-detail/ICONO_COMENTARIO.svg"
                  style="width: 18px; cursor: pointer"
                  tooltip="Crear comentario de producto"
                  placement="bottom"
                  (click)="openModalItem(item, 'comments')"
                  alt="Crear comentario de producto"
                />
              </span>

              <div
                class="d-flex align-items-center ml-1"
                style="border-left: 1px solid black; gap: 0.5em; height: 20px; padding-left: 0.75em; cursor: pointer"
                *ngIf="
                  item?.exceptions &&
                  item?.exceptions.length > 0
                "
              >
                <!-- Contenedor con tooltip personalizado -->

                <button
                  class="btn d-flex align-items-center p-0"
                  style="background-color: transparent; border: none; gap: 0.25em"
                  [disabled]="disabledButtons[item.id]"
                  (click)="showExceptionsTooltip($event, item.exceptions, item.id)"
                >
                  <img
                    src="../../../../assets/icons/itinerary-detail/WARNING.svg"
                    style="width: 20.5px"
                    [style.filter]="getAlertFilter(item)"
                    alt="Logs de eventos"
                  />

                  <p class="mb-0 date-room" style="margin-top: 1px">
                    {{ disabledButtons[item.id] ? "Abierto..." : "Ver logs de eventos" }}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <usb-popup
    [isLoading]="isLoadingCancel"
  >
    <div class="mb-3">
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="55" fill="currentColor" class="bi bi-ban cancel-loader_icon" viewBox="0 0 16 16">
        <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>
      </svg>
    </div>

    <h2 class="cancel-loader_title">Cancelando</h2>
    <h3 class="cancel-loader_subtitle mb-2">Producto</h3>
    <p class="cancel-loader_text">Procesando la cancelación del producto...</p>
  </usb-popup>
